import commonList from './commonList'
import TextTransformInput from './textTransformInput'

const components = [
  commonList,
  TextTransformInput
]

const install = function(Vue) {
  components.forEach(component => {
    Vue.component(component.name, component)
  })
}

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  install,
  commonList
}

export const CommonList = commonList
